.closeModal {
  position: absolute;
  top: 0.2em;
  right: 0.5em;
  font-size: 3em;
  color: var(--text-color);
  cursor: pointer;
  border: none;
  background: none;
}

/* -------------------------- */
/* CLASSES TO MAKE MODAL WORK */
.hidden {
  display: none;
}

.modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  color: var(--text-color);

  background-color: var(--background-color);
  padding: 4em;
  border-radius: 0.4em;
  box-shadow: 0 3rem 5rem rgba(0, 0, 0, 0.3);
  z-index: 10;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);
  z-index: 5;
}

.modalBtn {
  cursor: pointer;
  width: 4em;
  height: 4em;
  background-color: var(--accent-color);
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

#endGameModalTitle {
  display: flex;
  justify-content: center;
}

#actionBtns {
  margin-top: 1em;
  display: flex;
  justify-content: center;
  gap: 1em;
}

.playerScores {
  margin: 5em;
  display: flex;
  justify-content: space-around;
}
